import styles from './Loading.module.css'

interface LoadingProps {
  /** "cards" renders a skeleton grid, "rows" a table skeleton, "block" a single block */
  variant?: 'spinner' | 'cards' | 'rows' | 'block'
  count?: number
  label?: string
}

export function Loading({ variant = 'spinner', count = 6, label }: LoadingProps) {
  if (variant === 'spinner') {
    return (
      <div className={styles.spinnerWrap} role="status" aria-live="polite">
        <span className={styles.spinner} />
        {label && <span className={styles.label}>{label}</span>}
      </div>
    )
  }

  if (variant === 'cards') {
    return (
      <div className={styles.cardGrid} role="status" aria-label="로딩 중">
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className={styles.cardSkeleton} />
        ))}
      </div>
    )
  }

  if (variant === 'rows') {
    return (
      <div className={styles.rowWrap} role="status" aria-label="로딩 중">
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className={styles.rowSkeleton} />
        ))}
      </div>
    )
  }

  return <div className={styles.blockSkeleton} role="status" aria-label="로딩 중" />
}
